import { FC, ReactNode, Children, type ReactElement, cloneElement } from 'react';

import { isElement } from 'react-is';

import { invisibleClassName } from './pagination.css';

type Props = {
  children: ReactNode;
  isVisible: boolean;
};

/**
 * This wrapper hides its children when `isVisible` is true, but keeps
 * the space it would have taken up. It does not add any html elements, unless
 * the children are not React elements.
 *
 * See the MDN docs for more information on the `visibility` property:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/visibility
 */
export const ConditionalVisibility: FC<Props> = ({ isVisible, children }) => {
  if (isVisible) {
    return <>{children}</>;
  }

  const arrayChildren = Children.toArray(children);
  const hiddenChildren = Children.map(arrayChildren, child => {
    if (isElement(child)) {
      return cloneElement(child as ReactElement<{ className: string }>, { className: invisibleClassName });
    }
    return <div className={invisibleClassName}>{child}</div>;
  });

  return <>{hiddenChildren}</>;
};
